import React, { forwardRef, useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";
import { useParams } from "react-router";

const GenerateZipFile = forwardRef(({ Show, Hide, Title, sourceKey, getTotalS3Folders }, ref) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");

  const createS3ZipController = async () => {
    setButtonLoader(true)
    let userData = {  };
    userData.paths = sourceKey
    userData.zipName = name
    let data = await s3FileManagerServices.createS3ZipController(
      userData
    );
    setButtonLoader(false)
    if (data?.statusCode === 200) {
      setName("")
      getTotalS3Folders()
      Hide()
    }
  };

  return (
    <>
      <Modal show={Show} onHide={Hide} placement="end">
        <div ref={ref} className="d-flex flex-column h-100">
          <Modal.Header closeButton>
            <Modal.Title style={{fontSize: 15}}>{Title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Zip Name{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                rows={3}
                onChange={(e) => setName(e.target.value)}
                value={name}
                className="fontSize12"
                placeholder="Enter Zip Name"
              />
            </Form.Group>
          </Modal.Body>
          <div className="text-end p-2 border-top">
            <Button
              onClick={createS3ZipController}
              disabled={buttonLoader || !name}
              title={Title}
              size="sm"
              variant="outline-primary"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Compressing...
                </div>
              ) : (
                "Compress Now"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default GenerateZipFile;
